<app-link
    class="selenium-you-may-also-like"
    [class]="ymalClass >= 376 ? 'ymal-card' : 'ymal-card-clean'"
    [appRouterLink]="learningObject.routerLink"
    [ngClass]="{ 'preview-grayscale': isInPreviewMode$ | async }"
    [tabIndex]="(isInPreviewMode$ | async) ? -1 : 0"
>
    <div class="thumbnail">
        <app-language-badge
            *ngIf="
                learningObject.languages.length > 1 || learningObject.languages.includes('Spanish')
            "
            [languages]="learningObject.languages"
        ></app-language-badge>
        <app-resource-card-poster
            [posterImage]="learningObject.getPosterImage(269, 151)"
            [duration]="learningObject.duration"
            [gtmPrefix]="gtmPrefix"
            [title]="learningObject.linkTitle"
            [absoluteUrl]="learningObject.canonicalUrl"
        >
        </app-resource-card-poster>
    </div>
    <div class="content">
        <a [class]="getResourceBodyClass()" [attr.data-gtmlabel]="learningObject.canonicalUrl">
            <app-card-title [height]="44" [rows]="isCardLarge() ? 2 : 10">{{
                learningObject.title
            }}</app-card-title>
        </a>
        <div
            class="content-project-name"
            *ngIf="learningObject.project && learningObject.project.title"
        >
            {{ learningObject.project.title | safeTruncate: 25 }}
        </div>

        <app-ymal-card-meta
            [ngClass]="{ 'move-down': !learningObject.project }"
            [mediaType]="learningObject.mediaType[0]"
            [supportMaterialsCount]="learningObject.supportMaterials.length"
            [supportMaterialsLink]="learningObject.routerLink"
        >
        </app-ymal-card-meta>
    </div>
</app-link>
